
import {createReducer, on} from "@ngrx/store";
import {WarehouseActions} from ".";
import { Supply, WarehouseSupplyDetailsResponse, WarehouseSupplyLogsResponse } from "./interfaces/warehouse.modal";

export interface WarehouseState {
    supplyRawData: WarehouseSupplyDetailsResponse,
    supplyRawDataOfOrder: WarehouseSupplyDetailsResponse,
    supplyLogs: WarehouseSupplyLogsResponse,
    supplyTable: Supply[],
    error: any,
    showLoader : boolean,
  newlyAddedBatches: any,
  batchesSoldQuantityInfo: { allSold?: any[], error?: any[] },
  productsWithSerialNumber:any,
  closeModalActionNumber:number
  }

export const initialState:WarehouseState = {
  supplyRawData:{
    data: [],
    pagination: null,
    totalCount: null
  },
  supplyRawDataOfOrder:{
    data: [],
    pagination: null,
    totalCount: null
  },
  supplyLogs:{
    data: [],
    pagination: null,
  },
    supplyTable: [],
     error: null,
     showLoader : false,
  newlyAddedBatches: null,
  batchesSoldQuantityInfo: {},
  productsWithSerialNumber:{},
  closeModalActionNumber:0
  };

  export const WarehouseReducer = createReducer(
    initialState,
      on(WarehouseActions.loadSupplyListWithPaginationSuccess,(state, {response})=>{
        return{
          ...state,
          supplyRawData: response
        }
      }),
      on(WarehouseActions.loadSupplyListForOrderWithPaginationSuccess,(state, {response})=>{
        return{
          ...state,
          supplyRawDataOfOrder: response
        }
      }),
      on(WarehouseActions.warehouseFailureMethod,(state, {err})=>{
        return{
          ...state,
          error:err
        }
      }),
      on(WarehouseActions.createMultipleBatchSuccess,(state, {res})=>{
        return{
          ...state,
          newlyAddedBatches:res
        }
      }),
      on(WarehouseActions.createMultipleBatchForMultLocationsSuccess,(state, {res})=>{
        return{
          ...state,
          newlyAddedBatches:res
        }
      }),
    on(WarehouseActions.updateSoldBatchesQuantitySuccess, (state, { res }) => {
      return {
        ...state,
        batchesSoldQuantityInfo: res
      }
    }),
    on(WarehouseActions.updateBathcesWithProductDataSuccess, (state, { batchId,productsByBathces }) => {
      return {
        ...state,
        productsWithSerialNumber: { batchId, productsByBathces }
      }
    }),
    on(WarehouseActions.loadSelectedSupplyListByIdsSuccess, (state, { response }) => {
      const updatedSupplyRawData = {
        ...state.supplyRawData,
        data: state.supplyRawData.data.map(((supply) => {
          return ((response?.data || []).find(s => s._id === supply._id)) || supply
        }))
      }
      return {
        ...state,
        supplyRawData: updatedSupplyRawData
      }
    }),
    on(WarehouseActions.loadSupplyLogsForOrderWithPaginationSuccess,(state, {response})=>{
      return{
        ...state,
        supplyLogs: response
      }
    }),
    on(WarehouseActions.updateInventoryProductListStatus,(state, {statusNumber})=>{
      return{
        ...state,
        closeModalActionNumber:statusNumber
      }
    }),
  )
